(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/components/sportinfo/match-info-redux/assets/match-info-actions.js') >= 0) return;  svs.modules.push('/components/sportinfo/match-info-redux/assets/match-info-actions.js');
"use strict";

function _slicedToArray(r, e) { return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t.return && (u = t.return(), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(r) { if (Array.isArray(r)) return r; }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, e) { if ("object" != typeof t || !t) return t; var r; if ("undefined" != typeof Symbol && void 0 !== (r = t[Symbol.toPrimitive])) { var i = r.call(t, e || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === e ? String : Number)(t); }

const _RTK = RTK,
  createAsyncThunk = _RTK.createAsyncThunk,
  createAction = _RTK.createAction;
const normalizeEvent = svs.components.sportinfo.matchInfoRedux.normalizeEvent;
const normalizeEventTypeId = svs.components.sportinfo.common.helpers.normalizeEventTypeId;
const _svs$components$sport = svs.components.sportinfo.common.constants,
  EventTypes = _svs$components$sport.EventTypes,
  EventTypeId = _svs$components$sport.EventTypeId,
  OutcomeToAlphabeticStrings = _svs$components$sport.OutcomeToAlphabeticStrings,
  EventTypeDistributionsFallback = _svs$components$sport.EventTypeDistributionsFallback;
const logger = svs.core.log.getLogger('match-info:match-info-actions');
const ApiProxy = svs.components.lbUtils.apiProxy.ApiProxy;
const _svs$components$sport2 = svs.components.sportinfo.common.helpers,
  customSporteventApiHandler = _svs$components$sport2.customSporteventApiHandler,
  customSporteventOddsApiHandler = _svs$components$sport2.customSporteventOddsApiHandler;
const normalize1X2OddsItems = eventType => {
  if (eventType.length === 0) {
    return null;
  }
  return eventType.reduce((acc, outcome) => {
    acc[OutcomeToAlphabeticStrings[outcome.outcome]] = outcome.value;
    return acc;
  }, {});
};
const normalizeOddsResponse = (oddsResponse, productId, eventNumber, drawNumber) => _objectSpread(_objectSpread({}, oddsResponse), {}, {
  eventTypes: oddsResponse === null || oddsResponse === void 0 ? void 0 : oddsResponse.eventTypes.map(eventType => {
    const eventTypeId = normalizeEventTypeId({
      eventTypeId: eventType.eventTypeId,
      participantType: eventType.participantType,
      productId
    });
    const distribution = [];
    const startOdds = [];
    eventType.draws.map(draw => _objectSpread(_objectSpread({}, draw), {}, {
      events: draw.events.forEach(event => {
        if (eventTypeId === EventTypeId.HEAD_TO_HEAD && event.eventNumber !== eventNumber) {
          return null;
        }
        distribution.push({
          distribution: event.distribution,
          drawNumber: draw.drawNumber || EventTypeDistributionsFallback,
          eventNumber: event.eventNumber,
          productId: draw.productId,
          productName: draw.productName
        });
        if (draw.drawNumber === drawNumber) {
          event.startOdds.forEach(startOddsItem => {
            startOdds.push(startOddsItem);
          });
        }
      })
    }));
    return _objectSpread(_objectSpread({}, eventType), {}, {
      odds: eventType.odds.odds,
      favorite: eventType.odds.favourite,
      eventTypeId,
      distribution,
      startOdds
    });
  })
});
const normalizeDraws = draws => {
  if (!draws.length) {
    return [{
      distribution: [],
      startOdds: []
    }];
  }
  return draws.map(draw => {
    const events = draw.events;
    return events.map(event => _objectSpread(_objectSpread({}, event), {}, {
      startOdds: normalize1X2OddsItems(event.startOdds),
      distribution: _objectSpread(_objectSpread({}, normalize1X2OddsItems(event.distribution)), {}, {
        drawNumber: draw.drawNumber || EventTypeDistributionsFallback,
        eventNumber: event.eventNumber,
        productName: draw.productId
      }),
      drawNumber: draw.drawNumber || EventTypeDistributionsFallback,
      productName: draw.productId
    }));
  });
};
const normalizeOdds = oddsResponse => {
  let normalizedOdds = oddsResponse.eventTypes.map(_ref => {
    let eventSubType = _ref.eventSubType,
      eventType = _ref.eventType,
      eventTypeId = _ref.eventTypeId,
      odds = _ref.odds,
      favorite = _ref.favorite,
      draws = _ref.draws;
    if (eventType === EventTypes.EvenType1X2) {
      const drawsResponse = normalizeDraws(draws);
      return _objectSpread({
        eventSubType,
        eventTypeId,
        eventType,
        odds: normalize1X2OddsItems(odds),
        favorite: normalize1X2OddsItems(favorite)
      }, drawsResponse.pop());
    }
    logger.debug("Trying to parse odds for unsupported event type: ".concat(eventType));
    return false;
  }).filter(Boolean);
  if (!normalizedOdds.length) {
    normalizedOdds = [{
      eventSubType: EventTypes.EvenType1X2,
      eventType: null,
      odds: null,
      startOdds: null,
      favorite: null,
      distribution: null
    }];
  }
  return normalizedOdds;
};
const fetchMatchInfoService = _ref2 => {
  let matchId = _ref2.matchId,
    productId = _ref2.productId,
    eventNumber = _ref2.eventNumber,
    drawNumber = _ref2.drawNumber;
  return new Promise((resolve, reject) => {
    const apiProxySportEvent = new ApiProxy([customSporteventApiHandler]);
    const apiProxySportEventOdds = new ApiProxy([customSporteventOddsApiHandler]);
    (async () => {
      try {
        var _normalizedOdds;
        const eventPromise = apiProxySportEvent.fetch("/sport/1/sportevent/".concat(matchId), {
          method: 'GET',
          productId
        });
        const oddsPromise = apiProxySportEventOdds.fetch("/sport/2/sportevent/".concat(matchId, "/odds"), {
          method: 'GET',
          productId
        });
        const _await$Promise$allSet = await Promise.allSettled([eventPromise, oddsPromise]),
          _await$Promise$allSet2 = _slicedToArray(_await$Promise$allSet, 2),
          eventSettled = _await$Promise$allSet2[0],
          oddsSettled = _await$Promise$allSet2[1];
        const eventResponse = eventSettled.status === 'fulfilled' ? eventSettled.value : {
          error: eventSettled.reason
        };
        const oddsResponse = oddsSettled.status === 'fulfilled' ? oddsSettled.value : {
          error: oddsSettled.reason
        };
        let normalizedOddsResponse;
        let normalizedOdds;
        if (!oddsResponse.error) {
          normalizedOddsResponse = normalizeOddsResponse(oddsResponse, productId, eventNumber, drawNumber);
          normalizedOdds = normalizeOdds(normalizedOddsResponse);
        }
        const eventPayload = eventResponse.error ? eventResponse : normalizeEvent(eventResponse.sportEvent, (_normalizedOdds = normalizedOdds) === null || _normalizedOdds === void 0 || (_normalizedOdds = _normalizedOdds[0]) === null || _normalizedOdds === void 0 ? void 0 : _normalizedOdds.distribution);
        const oddsPayload = oddsResponse.error ? oddsResponse : _objectSpread(_objectSpread({}, normalizedOddsResponse), {}, {
          oddsInfo: normalizedOdds[0]
        });
        resolve([eventPayload, oddsPayload]);
      } catch (error) {
        reject(error);
      }
    })();
  });
};
const fetchMatchDataService = (matchId, productId) => new Promise((resolve, reject) => {
  const apiProxy = new ApiProxy([customSporteventApiHandler]);
  (async () => {
    try {
      const eventResponse = await apiProxy.fetch("/sport/1/sportevent/".concat(matchId), {
        method: 'GET',
        productId
      });
      resolve(eventResponse);
    } catch (error) {
      reject(error);
    }
  })();
});
const fetchMatchInfo = createAsyncThunk('fetchMatchInfo', _ref3 => {
  let matchId = _ref3.matchId,
    productId = _ref3.productId,
    eventNumber = _ref3.eventNumber,
    drawNumber = _ref3.drawNumber;
  return fetchMatchInfoService({
    matchId,
    productId,
    eventNumber,
    drawNumber
  });
});
const fetchMatchData = createAsyncThunk('fetchMatchData', _ref4 => {
  let matchId = _ref4.matchId,
    productId = _ref4.productId;
  return fetchMatchDataService(matchId, productId);
});
const updateMatchOdds = createAction('updateMatchOdds', (matchId, oddsResponse) => ({
  payload: {
    matchId,
    odds: _objectSpread(_objectSpread({}, oddsResponse), {}, {
      oddsInfo: normalizeOddsResponse(oddsResponse)[0]
    })
  }
}));
setGlobal('svs.components.sportinfo.matchInfoRedux.actions', {
  fetchMatchInfo,
  fetchMatchData,
  updateMatchOdds
});

 })(window);